import { useTranslations } from 'next-intl'
import { ScrollArea } from '@skop-app/lib-front'
import type { AdaptedProduct } from '@skop-app/lib-domain/types'
import { DynamicIcon } from '@/components/atoms/DynamicIcon'
import type { DynamicIconName } from '@/components/atoms/DynamicIcon'

import { formatProductDimensions } from '@/utils'

export const ProductDescription = ({
  product,
}: {
  product: AdaptedProduct
}) => {
  const t = useTranslations()

  const productItems: {
    label: string
    value: string | null
    icon?: DynamicIconName
  }[] = [
    {
      label: t('Product.brand'),
      value: product?.brand ?? null,
      icon: 'Queue',
    },
    {
      label: t('Product.reference'),
      value: product?.ref ?? null,
      icon: 'Queue',
    },
    {
      label: t('Product.complement'),
      value: product?.complement ?? null,
      icon: 'Plus',
    },
    {
      label: t('Product.complementEN'),
      value: product?.complementEN ?? null,
      icon: 'Plus',
    },
    {
      label: t('Product.complementNL'),
      value: product?.complementNL ?? null,
      icon: 'Plus',
    },
    {
      label: t('Product.condition'),
      value: product?.condition ?? null,
      icon: 'Plus',
    },
    {
      label: t('Product.price'),
      value: product?.price?.label ?? null,
      icon: 'CurrencyEur',
    },
    {
      label: t('Product.description'),
      value: product?.description ?? null,
      icon: 'Paragraph',
    },
    {
      label: t('Product.dimensions'),
      value:
        formatProductDimensions(product)?.label ??
        product?.dimensions?.label ??
        null,
      icon: 'Ruler',
    },
    {
      label: t('Product.provenance'),
      value: product?.provenance ?? null,
      icon: 'Sparkle',
    },
  ]

  return (
    <div className="flex flex-col gap-2.5">
      <p className="group relative flex w-full items-center justify-between text-left text-sm font-medium text-slate-800">
        {t('Product.presentation')}
      </p>
      <ScrollArea className="max-h-52">
        <div className="flex flex-col gap-1.5">
          {productItems.map((item) => {
            if (!item.value) return null

            return (
              <div
                className="relative flex items-center gap-2"
                key={item.value}
              >
                {item.icon && (
                  <DynamicIcon
                    weight="duotone"
                    name={item.icon}
                    className="absolute left-0 top-1 size-4"
                  />
                )}
                <p className="pl-6">
                  <span className="text-sm font-medium">{item.label}</span>
                  <span className="text-sm text-zinc-500">: {item.value}</span>
                </p>
              </div>
            )
          })}
        </div>
      </ScrollArea>
    </div>
  )
}
